export default "__VITE_ASSET__BqBYazHM__"